import type { EmergencyService } from "@/mocks/siteContent";

/** Builds the directory URL that shows the real listings behind an emergency service. */
export function buildEmergencyDirectoryHref(service: EmergencyService): string {
  const params = new URLSearchParams();
  if (service.category) {
    params.set("category", service.category);
  }
  if (service.keyword) {
    params.set("keyword", service.keyword);
  }
  const query = params.toString();
  return query ? `/directory?${query}` : "/directory";
}